import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import Heading from '../../../Heading';
import Amount from '../../../Amount';

// Icons
import GiftIcon from '../../../../icons/gift.svg';
import CartIcon from '../../../../icons/cart.svg';

// Styles
import styles from './Sauce.styl';

const cx = classNames.bind(styles);

export default function Sauce(props) {
  const { className, id, variations, name, gift, isAdding, addToCart } = props;

  const handleAddToCart = () => {
    return addToCart(id, variations[0]?.id);
  };

  const variation = variations[0];
  const { image_list, size, price } = variation;

  return (
    <div className={cx('Sauce', className)}>
      <figure className={cx('Sauce__image')}>
        <img src={image_list} alt={name} />
      </figure>
      <div className={cx('Sauce__content')}>
        <div className={cx('Sauce__info')}>
          <Heading className={cx('Sauce__name')}>{name}</Heading>
          <div className={cx('Sauce__note')}>
            {size?.value}&nbsp;{size?.unit}
          </div>
        </div>
        <div className={cx('Sauce__footer')}>
          {!gift && <Amount value={price} size="s" />}
          <button
            className={cx('Sauce__button', className)}
            onClick={handleAddToCart}
            type="button"
          >
            {isAdding ? (
              <div className={cx('Sauce__button-spinner')} />
            ) : (
              <div className={cx('Sauce__button-icon')}>
                {gift ? <GiftIcon width={26} height={26} /> : <CartIcon width={26} height={26} />}
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

Sauce.defaultProps = {
  className: '',
  gift: false,
  isAdding: false,
};

Sauce.propTypes = {
  className: PropTypes.string,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  gift: PropTypes.bool,
  isAdding: PropTypes.bool,
  addToCart: PropTypes.func.isRequired,
  variations: PropTypes.array.isRequired,
};
